import { useCallback, useState } from 'react';
import useApiCall from '../../../../../hooks/useApiCall';
import PassengersService from '../../../../../services/affreightment/PassengersService';
import { useAppContext } from '../../../../../contexts/auth';
import { toast } from 'react-toastify';

interface UseEditPassengerInterface {
  getPassengers: (workplaceCode: number) => void;
  workplaceCode: number;
  isReactivateDateSet: boolean;
  reactivateDate: string;
  reactivatePassengerCode: string | number;
}

export default function useActivatePassenger({ getPassengers, workplaceCode, isReactivateDateSet, reactivateDate, reactivatePassengerCode }: UseEditPassengerInterface) {
  const [isReactivating, setIsReactivating] = useState(false);

  const { apiCall } = useApiCall();
  const { selectedCompany, userData } = useAppContext();
  const companyCode = selectedCompany.value;
  const { userCode, userProfile } = userData;

  const currentDate = new Date().toJSON().slice(0, 10);

  const handleActivatePassenger = useCallback(async () => {
    await apiCall({
      apiToCall: PassengersService.editPassenger,
      queryParams: {
        codFuncionario: reactivatePassengerCode,
        ativado: true,
        provisorio: isReactivateDateSet ? true : false,
        dataInativoAte: isReactivateDateSet ? reactivateDate : currentDate,
        codUsu: userCode,
        perfilUsu: userProfile,
        codEmpresa: companyCode,
      },
      onStartLoad: () => setIsReactivating(true),
      onEndLoad: () => setIsReactivating(false),
      actionAfterResponse: (response) => {
        if (!response.codigo) {
          toast.error(`Não foi possível ${isReactivateDateSet ? 'reagendar a ativação do' : 'reativar o'} passageiro. Por favor, tente novamente (${response.msg})`);
          return;
        }
        toast.success(`${isReactivateDateSet ? 'Reativação agendada' : 'Reativação realizada'} com sucesso!`);
        getPassengers(workplaceCode);
      },
      catchMessage: `Não foi possível ${isReactivateDateSet ? 'reagendar a ativação do' : 'reativar o'} passageiro, Por favor, tente novamente`,
    });
  }, [apiCall, companyCode, currentDate, getPassengers, isReactivateDateSet, reactivateDate, reactivatePassengerCode, userCode, userProfile, workplaceCode]);

  return {
    isReactivating,
    handleActivatePassenger,
  };
}
